const PUBLIC_S3_ORIGIN = "https://vmsprojectdata.s3.ap-south-1.amazonaws.com";

export const getPublicS3Url = (key) => {
  if (!key) return "";

  const raw = String(key).trim();
  if (!raw) return "";

  if (/^data:/i.test(raw)) return raw;

  // If we already have a URL (including old presigned URLs), normalize to
  // direct public S3 URL by keeping only the object path and dropping query params.
  if (/^https?:\/\//i.test(raw)) {
    try {
      const url = new URL(raw);
      const host = url.hostname.toLowerCase();
      const path = url.pathname.replace(/^\/+/, "");

      if (
        host === "vmsprojectdata.s3.ap-south-1.amazonaws.com" ||
        host === "vmsprojectdata.s3.amazonaws.com"
      ) {
        return path ? `${PUBLIC_S3_ORIGIN}/${path}` : "";
      }

      return raw;
    } catch (error) {
      return raw;
    }
  }

  const normalizedKey = raw.replace(/^\/+/, "");
  return `${PUBLIC_S3_ORIGIN}/${normalizedKey}`;
};
